import React from 'react';
import { Globe, Users, Shield, Scale, UserCheck, Award } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const FEATURE_IMAGES = [
  'https://static.prod-images.emergentagent.com/jobs/34c8bb6f-039c-40ba-81b7-4a62b8e5b07a/images/2c0de61de413f17deadb837253c30a6a20471d5e45878a24368f6b8e6a0b200f.png',
  'https://static.prod-images.emergentagent.com/jobs/34c8bb6f-039c-40ba-81b7-4a62b8e5b07a/images/d2d341d29cacc592a0e1fee033685a7d6de995127b00a4f080b6c7a0ee09f5fa.png',
  'https://static.prod-images.emergentagent.com/jobs/34c8bb6f-039c-40ba-81b7-4a62b8e5b07a/images/33d66fbc474f61b24729c647c1f08ded15a23933dd05b5bce0823eb21fab978c.png',
  'https://static.prod-images.emergentagent.com/jobs/34c8bb6f-039c-40ba-81b7-4a62b8e5b07a/images/9ed35b5003175019a0d58a697a4b097e2dbe0c332d485c68458764c6b18addf8.png',
  'https://static.prod-images.emergentagent.com/jobs/34c8bb6f-039c-40ba-81b7-4a62b8e5b07a/images/c8ce409554cdb654c75720d0e8e39e7e36c713dd8d2b3f9c66ad31f4cb69ccde.png',
  'https://static.prod-images.emergentagent.com/jobs/34c8bb6f-039c-40ba-81b7-4a62b8e5b07a/images/645c616636371a802a62e8ecdbfa4c12e0272f78b04e7d8c23d2d7e62f06f883.png',
];

const AboutSection = () => {
  const { t } = useLanguage();

  const features = [
    { icon: Globe, title: t.globalPresence, desc: t.globalPresenceText },
    { icon: Users, title: t.regionalExpertise, desc: t.regionalExpertiseText },
    { icon: Shield, title: t.multiculturalTeam, desc: t.multiculturalTeamText },
    { icon: Scale, title: t.multiJurisdiction, desc: t.multiJurisdictionText },
    { icon: UserCheck, title: t.individualApproach, desc: t.individualApproachText },
    { icon: Award, title: t.provenReputation, desc: t.provenReputationText }
  ];

  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <div className="section-header centered">
          <h2 className="section-title">{t.aboutTitle}</h2>
          <p className="section-subtitle">{t.aboutSubtitle}</p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <h3 className="about-heading">{t.whoWeAre}</h3>
            <p className="about-paragraph">{t.aboutText1}</p>
            <p className="about-paragraph">{t.aboutText2}</p>
          </div>

          <div className="about-features-grid">
            {features.map((feature, index) => (
              <div key={index} className="about-feature-card">
                <img src={FEATURE_IMAGES[index]} alt={feature.title} className="about-feature-image" loading="lazy" />
                <div className="about-feature-text">
                  <h4 className="feature-title">{feature.title}</h4>
                  <p className="feature-desc">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
